let listenUserNotAuthCallback = null;
export const startListenUserNotAuthenticated = listenCallbackParam => {
  listenUserNotAuthCallback = listenCallbackParam;
};
const convertToJsonIfBlogJson = data => {
  if (
    data instanceof Blob &&
    data.type &&
    data.type.toLowerCase().indexOf("json") !== -1
  ) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.onload = () => {
        resolve(JSON.parse(reader.result));
      };
      reader.onerror = error => {
        reject(error);
      };

      reader.readAsText(data);
    });
  }
  return Promise.resolve(data);
};
const getError = async (error, messageError404 = 'Dados não encontrados') => {
  if (error.response) {  
    error.response.data = await convertToJsonIfBlogJson(error.response.data);
    if (error.response.data.message) {
      return new Error(error.response.data.message); // Se houver message, retorna string message
    } else if (
      typeof error.response.data === "string" &&
      error.response.data !== ""
    ) {
      return new Error(error.response.data);
    } else if (error.response.status === 400 && error.response.data.errors) {
      var e = new Error(
        error.response.data.errors.reduce(
          (msg, error) => msg.concat(error + "\n"),
          ""
        )
      );
      e.errors = error.response.data.errors;
      e.errorCodes = error.response.data.errorCodes;
      return e;
    } else if (error.response.status === 401) {
      return new Error("Usuário não autenticado, necessário autenticação.");
    } else if (error.response.status === 403) {
      return new Error("Usuário autenticado sem acesso ao recurso.");
    } else if (error.response.status === 404) {
      return new Error(messageError404);
    }
  } else if (error.request) {
    if (error instanceof Error) {
      return error;
    } else if (typeof error.toString() == "string") {
      return new Error(error.toString());
    }
  } else {
    // Something happened in setting up the request that triggered an Error
    // console.log('Error', error.toString());
  }
  return new Error("Could not process your request.");
};
export const handleError = (reject, messageError404 = '') => async error => {
  const treatedError = await getError(error, messageError404);
  if (error.response && error.response.status === 401) {
    if (listenUserNotAuthCallback) {
      listenUserNotAuthCallback(treatedError);
      return;
    }
  }
  reject(treatedError);
};


// export const handleError = async (reject, messageError404 = '') => {
//   var error = reject.error;
//   const treatedError = await getError(error, messageError404);
//   if (error.response && error.response.status === 401) {
//     if (listenUserNotAuthCallback) {
//       listenUserNotAuthCallback(treatedError);
//       return;
//     }
//   }
//   reject(treatedError);
// };
